import React from "react";

import { activityOptions } from "../../data";
import { CategoryContainer } from "../../components/CategoryContainer";
import { AutocompleteRHF } from "../../components/RHFWrappedComponents";

export function Activities() {
  return (
    <CategoryContainer title="Activities">
      <AutocompleteRHF
        name="academicInfo.activities"
        selectLabel="Activities You Participate(d) In"
        options={activityOptions}
        multiple={true}
      />
    </CategoryContainer>
  );
}
